import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=f1594ff6&scoped=true&"
import script from "./scripts.js?vue&type=script&lang=js&"
export * from "./scripts.js?vue&type=script&lang=js&"
import style0 from "./profile.vue?vue&type=style&index=0&id=f1594ff6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1594ff6",
  null
  
)

export default component.exports